export default "__VITE_ASSET__8f44eb85__"